import React, { useState, useEffect } from "react";

export const LiveDate: React.FC = () => {
  const [date, setDate] = useState<string>("");

  useEffect(() => {
    const updateDate = () => {
      const now = new Date();
      const options: Intl.DateTimeFormatOptions = {
        weekday: "long",
        month: "long",
        day: "numeric",
      };
      setDate(now.toLocaleDateString("id-ID", options));
    };

    updateDate();
    const interval = setInterval(updateDate, 60000); // update every 1 min

    return () => clearInterval(interval);
  }, []);

  return <span>{date}</span>;
};
